import React, { useEffect } from 'react'
import './Card_Sing.css'
import { signosInfo } from '../../common/constants/signos'
import { fetchHoroscope } from '../../application/usecases/fetchHoroscope.ts'
import { useAppDispatch, useAppSelector } from '../../infrastructure/redux/hooks.ts'

const CardSing = ({ sign }) => {
  const dispatch = useAppDispatch()
  const lowerSign = sign.toLowerCase()

  const { data, loading, error } = useAppSelector((state) => state.horoscope)

  useEffect(() => {
    dispatch(fetchHoroscope(lowerSign))
  }, [dispatch, lowerSign])

  const signData = signosInfo[lowerSign] || {}

  return (
    <div className="container_group_sign">
      <div className="card-sign">
        <div className="container-text-sign">
          <div className="container-image-sign">
            <div className="container-header-sign">
              <img alt={`logo ${sign}`} src={signData.img || "/images/default.png"} />
              <span>{sign}</span>
              <p className="custom-sign-sign">
                {signData.dates || "Fechas no disponibles"}
              </p>
            </div>

            <div className="text-sign">
              <h3 className="title-sign-description">Horóscopo diario {sign}</h3>

              {loading && <p>Cargando horóscopo...</p>}

              {error && <p className="error-message">Error: {error}</p>}

              {!loading && !error && (
                <p className="custom-long-sign">
                  <em>
                    <strong>{sign}</strong>, {data?.horoscope || 'Finding.'}
                  </em>
                </p>
              )}

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CardSing
